import { ACR_RESOURCE_TYPE } from '../pages/NRSettings/NRUsersAndAccess/rbac.constants';
import NRAssetIcon from '../NRIcons/NRAssetIcon';
import NROrganizationIcon from '../NRIcons/NROrganizationIcon';
import NRUsersIcon from '../NRIcons/NRUsersIcon';

const DEFAULT_ICON_SIZE = 24;

export function resolveAccessTagIcon(resourceType, color = 'currentColor', iconSize = DEFAULT_ICON_SIZE) {
  const iconProps = { height: iconSize, width: iconSize, color };

  switch (resourceType) {
    case ACR_RESOURCE_TYPE.ORGANIZATION:
      return <NROrganizationIcon {...iconProps} />;
    case ACR_RESOURCE_TYPE.ASSET_GROUP:
      return <NRUsersIcon {...iconProps} />;
    case ACR_RESOURCE_TYPE.ASSET:
      return <NRAssetIcon {...iconProps} />;
    default:
      return null;
  }
}

/** Maps grant tag summaries to the generic NRTagList tag shape (name, description, icon). */
export function mapAccessTagsToNrTags(tagSummaries = [], iconColor, iconSize = DEFAULT_ICON_SIZE) {
  return tagSummaries.map(({ roleName, resourceLabel, resourceType }) => ({
    name: roleName,
    value: roleName,
    description: resourceLabel || undefined,
    icon: resolveAccessTagIcon(resourceType, iconColor, iconSize)
  }));
}
